export type SeoRoute = {
  canonical: string;
  title: string;
  description: string;
};

export const SITE_URL = 'https://persianas-toldos-malaga.es';

export const SEO_ROUTES: Record<string, SeoRoute> = {
  '/': {
    canonical: 'https://persianas-toldos-malaga.es/',
    title: 'Persianas Toldos Málaga | Reparación e Instalación Pro',
    description: 'Empresa local de persianas, toldos y mosquiteras en Málaga. Reparación e instalación en toda la Costa del Sol. ☎ 951 12 07 70',
  },
  '/persianas': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/',
    title: 'Persianas en Málaga | Reparación, Motor y Cinta — 24h',
    description: 'Reparación de persianas en Málaga: motor, cinta, lamas. Visita en 24h, presupuesto gratis. Garantía 2 años. ☎ 951 12 07 70',
  },
  '/toldos': {
    canonical: 'https://persianas-toldos-malaga.es/toldos/',
    title: 'Toldos en Málaga | Instalación y Reparación Profesional',
    description: 'Instalación y reparación de toldos en Málaga: motorizados, cofre, extensibles. Presupuesto gratis 24h. ☎ 951 12 07 70',
  },
  '/mosquiteras': {
    canonical: 'https://persianas-toldos-malaga.es/mosquiteras/',
    title: 'Mosquiteras en Málaga | Enrollables, Correderas, Fijas',
    description: 'Mosquiteras a medida en Málaga: enrollables, correderas, fijas. Verano sin mosquitos. Presupuesto gratis. ☎ 951 12 07 70',
  },
  '/zonas': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/',
    title: 'Zonas de servicio | Persianas Toldos Málaga',
    description: 'Trabajamos en toda la Costa del Sol y comarcas del interior: 9 ciudades principales (Málaga, Marbella, Fuengirola...) y 3 comarcas (Axarquía, Guadalhorce, Serranía de Ronda).',
  },
  '/zonas/malaga': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/malaga/',
    title: 'Persianas y Toldos en Málaga Capital | Empresa local',
    description: 'Empresa local en Málaga capital: persianas, toldos y mosquiteras. Técnico propio, sin intermediarios, visita 24h y presupuesto gratis. ☎ 951 12 07 70.',
  },
  '/zonas/marbella': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/marbella/',
    title: 'Persianas y Toldos en Marbella | Empresa local',
    description: 'Empresa local en Marbella: persianas, toldos y mosquiteras. Puerto Banús, Nueva Andalucía. Sin intermediarios, visita 24h y presupuesto gratis.',
  },
  '/zonas/fuengirola': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/fuengirola/',
    title: 'Persianas y Toldos en Fuengirola | Empresa local',
    description: 'Empresa local en Fuengirola y Los Boliches: persianas, toldos y mosquiteras. Técnico propio, presupuesto gratis, visita 24h garantizada.',
  },
  '/zonas/torremolinos': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/torremolinos/',
    title: 'Persianas y Toldos en Torremolinos | Empresa local',
    description: 'Empresa local en Torremolinos, La Carihuela y Playamar: persianas, toldos y mosquiteras. Sin intermediarios, visita 24h y presupuesto gratis.',
  },
  '/zonas/benalmadena': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/benalmadena/',
    title: 'Persianas y Toldos en Benalmádena | Empresa local',
    description: 'Empresa local en Benalmádena Costa, Pueblo y Arroyo de la Miel: persianas, toldos y mosquiteras. Técnico propio, presupuesto gratis, visita 24h.',
  },
  '/zonas/mijas': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/mijas/',
    title: 'Persianas y Toldos en Mijas | Empresa local',
    description: 'Empresa local en Mijas Pueblo, Mijas Costa, La Cala y Calahonda: persianas, toldos y mosquiteras. Presupuesto gratis, visita 24h garantizada.',
  },
  '/zonas/estepona': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/estepona/',
    title: 'Persianas y Toldos en Estepona | Empresa local',
    description: 'Empresa local en Estepona y urbanizaciones: persianas, toldos y mosquiteras. Puerto, centro, campo de golf. Visita 24h, presupuesto sin compromiso.',
  },
  '/zonas/axarquia': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/axarquia/',
    title: 'Persianas y Toldos en la Axarquía | Empresa local',
    description: 'Empresa local en toda la Axarquía: persianas, toldos y mosquiteras en Frigiliana, Cómpeta, Comares y Nerja. Visita 24h, presupuesto gratis.',
  },
  '/zonas/valle-del-guadalhorce': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/valle-del-guadalhorce/',
    title: 'Persianas y Toldos en Valle del Guadalhorce | Empresa local',
    description: 'Empresa local en el Valle del Guadalhorce: persianas, toldos y mosquiteras en Cártama, Coín, Álora y Alhaurín. Técnico propio, visita 24h.',
  },
  '/zonas/serrania-de-ronda': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/serrania-de-ronda/',
    title: 'Persianas y Toldos en la Serranía de Ronda | Empresa local',
    description: 'Empresa local en la Serranía de Ronda: persianas, toldos y mosquiteras en Júzcar, Gaucín y Casares. Presupuesto gratis, visita 24h garantizada.',
  },
  '/zonas/velez-malaga': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/velez-malaga/',
    title: 'Persianas y Toldos en Vélez-Málaga | Empresa local',
    description: 'Empresa local en Vélez-Málaga y Torre del Mar: persianas, toldos y mosquiteras. Cobertura Axarquía baja completa. Presupuesto gratis, visita 24h.',
  },
  '/zonas/rincon-de-la-victoria': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/rincon-de-la-victoria/',
    title: 'Persianas y Toldos en Rincón de la Victoria | Empresa local',
    description: 'Empresa local en Rincón de la Victoria y La Cala del Moral: persianas, toldos y mosquiteras. Visita 24h, garantía 2 años, presupuesto gratis.',
  },
  '/zonas/benahavis': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/benahavis/',
    title: 'Persianas y Toldos en Benahavís | La Quinta, El Madroñal',
    description: 'Empresa local en Benahavís: persianas, toldos y mosquiteras en urbanizaciones golf (La Quinta, El Madroñal). Domótica, motores premium, visita 24h.',
  },
  '/zonas/san-pedro-de-alcantara': {
    canonical: 'https://persianas-toldos-malaga.es/zonas/san-pedro-de-alcantara/',
    title: 'Persianas y Toldos en San Pedro de Alcántara | Empresa local',
    description: 'Empresa local en San Pedro de Alcántara: persianas, toldos y mosquiteras en Guadalmina, Linda Vista y centro. Presupuesto gratis, visita 24h.',
  },
  '/persianas/malaga': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/malaga/',
    title: 'Persianas en Málaga | Reparación motor, cinta, lamas 24h',
    description: 'Especialistas en persianas en Málaga capital: motor, cinta, lamas, reparación urgente 24h. Garantía 2 años. Desde 60€.',
  },
  '/persianas/marbella': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/marbella/',
    title: 'Persianas en Marbella | Motor Somfy, cinta, urgencias',
    description: 'Reparación de persianas en Marbella, Puerto Banús y Nueva Andalucía. Motores anti-salitre, visita 24h, garantía 2 años.',
  },
  '/persianas/fuengirola': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/fuengirola/',
    title: 'Persianas en Fuengirola | Reparación motor y cinta 24h',
    description: 'Reparación de persianas en Fuengirola: Los Boliches, Torreblanca, centro. Motor, cinta, lamas. Visita 24h.',
  },
  '/persianas/torremolinos': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/torremolinos/',
    title: 'Persianas en Torremolinos | Motor, cinta, La Carihuela',
    description: 'Reparación de persianas en Torremolinos: La Carihuela, Playamar, Montemar. Motores reducidos para cajones estrechos.',
  },
  '/persianas/benalmadena': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/benalmadena/',
    title: 'Persianas en Benalmádena | Reparación motor 24h',
    description: 'Reparación de persianas en Benalmádena Costa, Pueblo y Arroyo de la Miel. Motores de torque alto para ventanales.',
  },
  '/persianas/mijas': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/mijas/',
    title: 'Persianas en Mijas | La Cala, Calahonda, motor 24h',
    description: 'Persianas en Mijas: pueblo y costa (La Cala, Calahonda, Riviera). Reparación motor, cinta, persianas tradicionales.',
  },
  '/persianas/estepona': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/estepona/',
    title: 'Persianas en Estepona | Motor domótico, urbanizaciones',
    description: 'Reparación de persianas en Estepona: centro, puerto, urbanizaciones golf. Motores KNX/Z-Wave para domótica.',
  },
  '/persianas/velez-malaga': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/velez-malaga/',
    title: 'Persianas en Vélez-Málaga | Torre del Mar, motor 24h',
    description: 'Persianas en Vélez-Málaga: casco histórico y Torre del Mar. Reparación motor, cinta, persianas mallorquinas tradicionales.',
  },
  '/persianas/rincon-de-la-victoria': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/rincon-de-la-victoria/',
    title: 'Persianas en Rincón de la Victoria | Motor IP44 24h',
    description: 'Persianas en Rincón de la Victoria y La Cala del Moral. Motores anti-corrosión IP44 para urbanizaciones modernas.',
  },
  '/persianas/benahavis': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/benahavis/',
    title: 'Persianas en Benahavís | Domótica, motores Somfy, urbanizaciones golf',
    description: 'Reparación de persianas en Benahavís: La Quinta, El Madroñal, El Paraíso. Especialistas en motores domotizados Somfy y Becker.',
  },
  '/persianas/san-pedro-de-alcantara': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/san-pedro-de-alcantara/',
    title: 'Persianas en San Pedro de Alcántara | Motor, cinta 24h',
    description: 'Reparación de persianas en San Pedro de Alcántara, Guadalmina y Linda Vista. Motores Somfy, cintas, lamas. Visita 24h.',
  },
  '/persianas/pannes/persiana-no-sube': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/pannes/persiana-no-sube/',
    title: 'Persiana no sube | Reparación urgente 24h en Málaga',
    description: '¿Tu persiana no sube? Diagnosticamos en 5 min. Causas: cinta rota (45%), motor estropeado (30%), lamas desencajadas (15%). Reparación 24h. Desde 60€.',
  },
  '/persianas/pannes/no-baja': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/pannes/no-baja/',
    title: 'Persiana no baja | Reparación urgente 24h en Málaga',
    description: '¿Tu persiana no baja? Causas: cinta enredada (40%), freno del recogedor bloqueado (25%), lamas atascadas (20%). Reparación 24h en Málaga. Desde 60€.',
  },
  '/persianas/pannes/hace-ruido': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/pannes/hace-ruido/',
    title: 'Persiana hace ruido | Diagnóstico y reparación 24h en Málaga',
    description: 'Persiana que chirria, golpea o vibra? Causas: guías sucias (35%), rodamientos gastados (30%), lamas sueltas (20%). Silenciamos tu persiana en 24h.',
  },
  '/persianas/pannes/caida-cinta': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/pannes/caida-cinta/',
    title: 'Cinta de persiana caída | Reparación urgente 24h en Málaga',
    description: '¿Se te ha caído la cinta de la persiana? Reparamos en 30 min. Cambio de cinta desde 60€. Servicio 24h en Málaga capital y Costa del Sol.',
  },
  '/persianas/pannes/motor-estropeado': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/pannes/motor-estropeado/',
    title: 'Motor de persiana estropeado | Reparación 24h en Málaga',
    description: '¿Motor de persiana quemado o sin fuerza? Reparamos condensador, final de carrera o sustituimos motor completo. Desde 80€. 24h en Málaga.',
  },
  '/persianas/pannes/lamas-rotas': {
    canonical: 'https://persianas-toldos-malaga.es/persianas/pannes/lamas-rotas/',
    title: 'Lamas de persiana rotas | Reparación 24h en Málaga',
    description: '¿Lamas de persiana rotas, dobladas o descoloridas? Cambiamos lamas individuales desde 15€/lama. Reparación 24h en Málaga capital y Costa del Sol.',
  },
  '/contacto': {
    canonical: 'https://persianas-toldos-malaga.es/contacto/',
    title: 'Contacto | Persianas Toldos Málaga ☎ 951 12 07 70',
    description: 'Contacta con Persianas Toldos Málaga. Teléfono 951 12 07 70, WhatsApp 627 21 33 47. Presupuesto gratis 24h.',
  },
};

export const DEFAULT_OG_IMAGE = 'https://persianas-toldos-malaga.es/og/og-default.jpg';

export function getSeoForPath(pathname: string): SeoRoute {
  const normalized = pathname.replace(/\/$/, '') || '/';
  return SEO_ROUTES[normalized] || SEO_ROUTES['/'];
}